import { isPlatform } from '@ionic/core';

export default () => isPlatform('mobileweb') || isPlatform('desktop');

export const isIos = () => isPlatform('ios');
